import { handleError } from "@network/handle-errors";
import {
  http,
  saveUserData,
  clearLocalStorage,
  addHeaders,
} from "@network/http";

const createDispatch = (data, tools, actions) => {
  const { type, payload } = data;
  const { state, update, reset, addState } = tools;

  const authentication = () => {
    const callback = payload.callback;
    if (state?.authed) return;
    http
      .get("/my-home")
      .then((response) => {
        const user = response?.data?.data;
        const membershipShow = user?.membership?.show_popup;
        saveUserData(user);
        update({
          user,
          membershipShow,
          authed: true,
          authLoad: false,
          policyVerificationOpen: !user.is_policy_verified,
          modals: {
            adsInOpen: user?.in_app_ad,
          },
        });
        callback && callback(user);
      })
      .catch((error) => {
        update({ user: null, authed: false, authLoad: false, isLoaded: true });
        clearLocalStorage();
        handleError(error);
      });
  };

  const getFundsBySearch = async () => {
    const { fundsParams, reset } = payload;
    if (reset) {
      update(
        {
          page: 1,
          items: [],
          hasMore: false,
          loading: false,
          fundsParams: {},
        },
        "homeFundsSearch"
      );
      addState({ fundsInview: false });
    }
    const search = state?.search;
    const funds = state?.homeFundsSearch;
    if (funds?.loading) return;
    let fundsUrl = `/all-funds-with-name-filter`;
    try {
      addState({ loading: true, fundsParams }, "homeFundsSearch");
      let page = funds?.page || 1;
      fundsUrl = `${fundsUrl}?page=${page}&fund_name=${search}`;
      const res = await http.get(fundsUrl, {
        params: fundsParams,
      });
      const data = res.data?.data;
      const newData = data?.items;
      const oldItems = funds?.items;

      const newFunds = {
        search,
        page: page + 1,
        items: [...oldItems, ...newData],
        loading: false,
        hasMore: data?.meta?.has_other_pages,
      };

      update(newFunds, "homeFundsSearch");
      return newFunds;
    } catch (error) {
      handleError(error);
    }
  };

  const getFaq = async () => {
    const { lang } = payload;
    const faq = state?.faq;
    if (faq?.loading) return;
    try {
      addState({ loading: true }, "faq");
      update({ loadingMore: true });
      const page = faq?.page || 1;
      const res = await http.get(`/get-faqs?page=${page}`, addHeaders(lang));
      const data = res.data?.data?.items;
      const oldItems = faq?.items;
      addState(
        {
          page: page + 1,
          loading: false,
          loadingMore: false,
          items: [...oldItems, ...data],
          hasMore: res?.data?.data?.meta?.has_other_pages,
        },
        "faq"
      );
      update({ searchItems: [...oldItems, ...data] });
    } catch (error) {
      handleError(error);
    }
  };

  const logout = () => {
    http.post("/app-logout").then(() => {
      update({ user: null, authed: false });
      reset(["transactions", "overview_statistic"]);
      update(
        {
          page: 1,
          items: [],
          loading: false,
          hasMore: false,
        },
        "notifications"
      );
      clearLocalStorage();
      payload && payload();
    });
  };

  switch (type) {
    case actions.authentication:
      return authentication();
    case actions.logout:
      return logout();
    case actions.getFundsBySearch:
      return getFundsBySearch();
    case actions.getFaq:
      return getFaq();
    default:
      break;
  }
};

export default createDispatch;
